import {
  firstName,
  middleName,
  lastName,
  email,
  emailConfirm,
  phoneType,
  recaptchaChallengeToken,
} from '@mgo/core/src/validations/person';
import { phoneNumber } from '../../utils/contactPhoneNumber';

import {
  startDate,
  stopDate,
  moverType,
  forwardType,
  familySameLastName,
  familyRemaining,
  businessWholeCompany,
  businessName,
  businessAlias1,
  businessAlias2,
  businessAlias3,
  businessAlias4,
} from '@mgo/core/src/validations/coa';

export default {
  firstName,
  middleName,
  lastName,
  email,
  emailConfirm,
  phoneNumber,
  phoneType,
  startDate,
  stopDate,
  moverType,
  forwardType,
  familySameLastName,
  familyRemaining,
  businessWholeCompany,
  businessName,
  businessAlias1,
  businessAlias2,
  businessAlias3,
  businessAlias4,
  recaptchaChallengeToken,
};
